import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from 'lodash';
import { BarLoader } from '@unite-us/app-components';
import Note from '../Note';
import NoNotes from '../NoNotes';
import { getDurationDisplayName } from '../utils/notesUtils';

const NotesCollection = ({
  currentEmployeeId,
  displayNotes,
  durations,
  editingNoteId,
  isLoading,
  notesContainerId,
  onCancelEdit,
  onEdit,
  reason,
  rideHealthConfig,
  showDeleteNoteIcon,
  showEditNoteIcon,
  subjectType,
}) => (
  <div id={notesContainerId} data-test-element={notesContainerId}>
    {isLoading ? (
      <BarLoader className="h-60" size="full" />
    ) : null}
    {!isLoading && isEmpty(displayNotes) ? (
      <NoNotes subjectType={subjectType} />
    ) : null}
    {displayNotes.map((note) => (
      <div
        className="mb-4"
        data-test-element={`note-${note.id}`}
        key={`${note.id}-${note.created_at || note.text}`}
      >
        <Note
          currentEmployeeId={currentEmployeeId}
          duration={getDurationDisplayName(durations, note.duration)}
          isEditing={editingNoteId === note.id}
          interactionDate={note.interactionDate}
          interactionType={note.interactionType}
          category={note.category}
          onCancelEdit={onCancelEdit}
          onEdit={() => onEdit(note.id)}
          text={note.text}
          details={note.details}
          note={note}
          renderTextAsHtml={Boolean(rideHealthConfig)}
          reason={reason}
          showEditNoteIcon={showEditNoteIcon}
          visibility={note.visibility}
          showDeleteNoteIcon={showDeleteNoteIcon}
        />
      </div>
    ))}
  </div>
);

NotesCollection.propTypes = {
  currentEmployeeId: PropTypes.string.isRequired,
  displayNotes: PropTypes.array.isRequired,
  durations: PropTypes.array.isRequired,
  editingNoteId: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  notesContainerId: PropTypes.string.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  reason: PropTypes.string,
  rideHealthConfig: PropTypes.object,
  showDeleteNoteIcon: PropTypes.bool.isRequired,
  showEditNoteIcon: PropTypes.bool.isRequired,
  subjectType: PropTypes.string.isRequired,
};

NotesCollection.defaultProps = {
  editingNoteId: null,
  reason: null,
  rideHealthConfig: null,
};

export default NotesCollection;
